const headers = [
  {
    text: 'nextengine.nextengine_ec-goods-number',
    value: 'goodsId',
    sortable: false,
    width: '8%',
    align: 'center'
  },
  {
    text: 'nextengine.nextengine_ec-goods-name',
    value: 'goodsName',
    sortable: false,
    width: '15%',
    align: 'center'
  },
  {
    text: 'nextengine.nextengine_ec-goods-supplier-name',
    value: 'goodsSupplierName',
    sortable: false,
    width: '10%',
    align: 'center'
  },
  {
    text: 'nextengine.nextengine_spes-product-number',
    value: 'linkedProduct.productNumber',
    sortable: false,
    width: '8%',
    align: 'center'
  },
  {
    text: 'nextengine.nextengine_spes-product-name',
    value: 'linkedProduct.nameJp',
    sortable: false,
    width: '15%',
    align: 'center'
  },
  {
    text: 'payment.payment_operation',
    value: 'edit',
    sortable: false,
    width: '5%',
    align: 'center'
  }
]
export default { headers }
